import { FormBorrowContainer } from "../../../containers/borrowSystem/BorrowForm/FormBorrowContainer"

export function FormBorrowPage() {
    return (
        <FormBorrowContainer />
    )
}